import { isDevelopment } from './env';
import { localPort } from './ports';
import { protocol } from './protocol';
import { webConfig } from './webConfig';

export const APP_DEV_HOST = `127.0.0.1:${localPort(5000)}`;

/**
 *  The host used when running the app locally.
 */
export const APP_DEV_LOCALHOST = `localhost:${localPort(5000)}`;

/**
 * Returns the main application domain.
 */
export function getApplicationDomain(): string {
    // Running on Firebase
    return getAppDomainFromConfig();
}

/**
 * Return the fully qualified application domain with protocol.
 */
export function getApplicationEndpoint(): string {
    return `${protocol}://${getApplicationDomain()}`;
}

function getAppDomainFromConfig(): string {
    // Running in development
    if (isDevelopment) {
        return APP_DEV_HOST;
    }

    return webConfig.firebase.authDomain;
}
